;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/PictureHero',["jquery", "eventManager", "score_bootstrap/Base/PictureAsBackground"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require("score_bootstrap/Base/PictureAsBackground")) :
    console && console.error('PictureHero does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, PictureAsBackground) {
    
    function PictureHero(scope) {
        ///<summary>Initialize a new instance of PictureStripe.</summary>

        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

        PictureAsBackground.call(this, scope, '> picture', '> .score-editField-group > .pic-thumb > picture');
    }

    PictureHero.prototype = Object.create(PictureAsBackground.prototype);

    PictureHero.init = function init(args) {
        return new PictureHero(args.scope);
    };

    return PictureHero;
}));
